/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskCategory } from './RiskCategory';
import { RiskCategoryFromJSON, RiskCategoryFromJSONTyped, RiskCategoryToJSON } from './RiskCategory';

/**
 *
 * @export
 * @interface PaginatedRiskCategoryList
 */
export interface PaginatedRiskCategoryList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskCategoryList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskCategoryList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskCategoryList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskCategory>}
   * @memberof PaginatedRiskCategoryList
   */
  results: Array<RiskCategory>;
}

/**
 * Check if a given object implements the PaginatedRiskCategoryList interface.
 */
export function instanceOfPaginatedRiskCategoryList(value: object): value is PaginatedRiskCategoryList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskCategoryListFromJSON(json: any): PaginatedRiskCategoryList {
  return PaginatedRiskCategoryListFromJSONTyped(json, false);
}

export function PaginatedRiskCategoryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskCategoryList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskCategoryFromJSON),
  };
}

export function PaginatedRiskCategoryListToJSON(value?: PaginatedRiskCategoryList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskCategoryToJSON),
  };
}
